export const APP_CONTS = {
  FILES: {
    CAT_ESP_FORMAT: ['image/png', 'image/jpeg', 'application/pdf'],
    IMAGE_FORMAT: ['image/png', 'image/jpeg'],
    IMAGE_FORMAT_STR: 'image/png, image/jpeg',
    DOC_FORMAT: ['application/pdf'],
    DOC_FORMAT_STR: 'application/pdf',
    EXCEL_FORMAT: [
      'application/vnd.ms-excel',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    EXCEL_FORMAT_STR: 'application/vnd.ms-excel, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    MAX_FILE_SIZE_MB: 10
  }
};



// WEBPACK FOOTER //
// /app/src/app/app.constants.ts